/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Row,
  Col,
  Panel,
  Grid,
} from 'react-bootstrap';
import Toolbar from 'loracoms/Toolbar';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { routerActions } from 'react-router-redux';
import InlineSelect from 'loracoms/InlineSelect';
import { callAPI } from 'lorautils/api';
import ScatterChart from 'loracoms/ScatterChart';

const propTypes = {
  id: React.PropTypes.any.isRequired,
  pushState: React.PropTypes.func.isRequired,
  intl: React.PropTypes.any.isRequired,
};

class DeviceQualityView extends React.Component {
  constructor(props) {
    super(props);
    this.intlMsg = new IntlMsg(props.intl, 'network.qualityView');
    this.state = {
      signalDataList: null,
      lossDataList: null,
      initialStatus: 'pending',
      queryHours: 6,
    };
  }

  componentDidMount() {
    this.mounted = true;
    this.loadDeviceAnalysisList();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  loadDeviceAnalysisList() {
    this.setState({ initialStatus: 'loading' });

    callAPI({
      endpoint: '/na/device_signal',
      query: {
        start_time: moment().subtract(this.state.queryHours, 'hours').unix(),
        end_time: moment().unix(),
        deveui: this.props.id,
      },
    }).then((data) => {
      if (this.mounted) {
        this.setState({
          initialStatus: 'success',
          signalDataList: data,
        });
      }
    }).catch(() => {
      this.setState({
        initialStatus: 'failure',
      });
    });
    callAPI({
      endpoint: '/na/device_packet_loss',
      query: {
        start_time: moment().subtract(this.state.queryHours, 'hours').unix(),
        end_time: moment().unix(),
        deveui: this.props.id,
      },
    }).then((data) => {
      if (this.mounted) {
        this.setState({
          initialStatus: 'success',
          lossDataList: data,
        });
      }
    }).catch(() => {
      this.setState({
        initialStatus: 'failure',
      });
    });
  }

  render() {
    const { id } = this.props;
    const breadcrumb = [{
      content: this.intlMsg.msg('title'),
      onClick: () => this.props.pushState('/network/quality'),
    }, {
      content: id,
      active: true,
    }];
    const signalDataList = this.state.signalDataList || [];
    const signalSNRScatterData = [];
    const signalRSSIScatterData = [];
    const frequencyDict = {};
    if (signalDataList.length !== 0) {
      for (let i = 0; i < signalDataList.length; i += 1) {
        let row = [
          moment.unix(signalDataList[i].ts / 1000).format('YYYY/MM/DD HH:mm'),
          signalDataList[i].lorasnr,
          signalDataList[i].rssi,
          String(signalDataList[i].frequency),
        ];
        frequencyDict[String(signalDataList[i].frequency)] = '';
        signalSNRScatterData.push(row);
        row = [
          moment.unix(signalDataList[i].ts / 1000).format('YYYY/MM/DD HH:mm'),
          signalDataList[i].rssi,
          signalDataList[i].lorasnr,
          String(signalDataList[i].frequency),
        ];
        signalRSSIScatterData.push(row);
      }
    }
    const frequencyList = Object.keys(frequencyDict);
    const lossDataList = this.state.lossDataList || [];
    const lossScatterData = [];
    if (lossDataList.length !== 0) {
      for (let i = 0; i < lossDataList.length; i += 1) {
        const row = [
          moment.unix(lossDataList[i].ts / 1000).format('YYYY/MM/DD HH:mm'),
          lossDataList[i].lost,
        ];
        lossScatterData.push(row);
      }
    }
    const hoursStr = this.intlMsg.msg('hours');
    const rightTools = [{
      type: 'buttons',
      buttons: [(
        <InlineSelect
          options={[{
            label: '1 ' + hoursStr,
            value: 1,
          }, {
            label: '6 ' + hoursStr,
            value: 6,
          },
          {
            label: '12 ' + hoursStr,
            value: 12,
          }, {
            label: '24 ' + hoursStr,
            value: 24,
          }, {
            label: '72 ' + hoursStr,
            value: 72,
          }]}
          values={[this.state.queryHours]}
          onChange={(selected) => {
            this.setState({
              queryHours: selected[0]
            }, () => {
              this.loadDeviceAnalysisList();
            });
          }}
        />
      )],
    }];
    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            <Toolbar breadcrumb={breadcrumb} rightTools={rightTools} />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Panel bsStyle="aisz-white" header={'SNR'}>
              <ScatterChart
                series={[{
                  type: 'scatter',
                  data: signalSNRScatterData,
                }]}
                tooltip={{
                  formatter: (obj) => 'Time: ' + obj.data[0] + '<br>' +
                            'RSSI: ' + obj.data[1] + '<br>' +
                            'SNR: ' + obj.data[2] + '<br>' +
                            'Frequency: ' + obj.data[3] + '<br>'
                }}
                dataZoom={[
                  {
                    show: true,
                    realtime: true,
                    start: 0,
                    end: 100,
                  },
                  {
                    type: 'inside',
                    realtime: true,
                    start: 0,
                    end: 100,
                  },
                ]}
                grid={{
                  left: 50,
                  top: 50,
                  right: 40,
                }}
                xAxis={{
                  type: 'time',
                  splitLine: {
                    lineStyle: {
                      type: 'dashed',
                    },
                  },
                }}
                yAxis={{
                  name: 'SNR',
                  splitLine: {
                    lineStyle: {
                      type: 'dashed',
                    },
                  },
                }}
                visualMap={[{
                  orient: 'horizontal',
                  align: 'left',
                  top: 0,
                  categories: frequencyList,
                  dimension: 3,
                  inRange: {
                    color: ['#313695', '#4575b4', '#74add1', '#abd9e9', '#e0f3f8',
                      '#ffffbf', '#fee090', '#fdae61', '#f46d43', '#d73027', '#a50026'],
                  },
                }]}
              />
            </Panel>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Panel bsStyle="aisz-white" header={'RSSI'}>
              <ScatterChart
                series={[{
                  type: 'scatter',
                  data: signalRSSIScatterData,
                }]}
                tooltip={{
                  formatter: (obj) => 'Time: ' + obj.data[0] + '<br>' +
                            'RSSI: ' + obj.data[1] + '<br>' +
                            'SNR: ' + obj.data[2] + '<br>' +
                            'Frequency: ' + obj.data[3] + '<br>'
                }}
                dataZoom={[
                  {
                    show: true,
                    realtime: true,
                    start: 0,
                    end: 100,
                  },
                  {
                    type: 'inside',
                    realtime: true,
                    start: 0,
                    end: 100,
                  },
                ]}
                grid={{
                  left: 50,
                  top: 50,
                  right: 40,
                }}
                xAxis={{
                  type: 'time',

                  splitLine: {
                    lineStyle: {
                      type: 'dashed',
                    },
                  },
                }}
                yAxis={{
                  name: 'SNR',

                  splitLine: {
                    lineStyle: {
                      type: 'dashed',
                    },
                  },
                }}
                visualMap={[{
                  orient: 'horizontal',
                  align: 'left',
                  top: 0,
                  categories: frequencyList,
                  dimension: 3,
                  inRange: {
                    color: ['#313695', '#4575b4', '#74add1', '#abd9e9', '#e0f3f8',
                      '#ffffbf', '#fee090', '#fdae61', '#f46d43', '#d73027', '#a50026'],
                  },
                }]}
              />
            </Panel>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Panel bsStyle="aisz-white" header={this.intlMsg.msg('loss')}>
              <ScatterChart
                series={[{
                  type: 'scatter',
                  data: lossScatterData,
                }]}
                tooltip={{
                  formatter: (obj) => 'Time: ' + obj.data[0] + '<br>' +
                                      'Lost: ' + obj.data[1] + '<br>'
                }}
                dataZoom={[
                  {
                    show: true,
                    realtime: true,
                    start: 0,
                    end: 100,
                  },
                  {
                    type: 'inside',
                    realtime: true,
                    start: 0,
                    end: 100,
                  },
                ]}
                grid={{
                  left: 50,
                  top: 30,
                  right: 40,
                }}
                xAxis={{
                  type: 'time',
                  splitLine: {
                    lineStyle: {
                      type: 'dashed',
                    },
                  },
                }}
                yAxis={{
                  name: 'Loss',
                  splitLine: {
                    lineStyle: {
                      type: 'dashed',
                    },
                  },
                }}
                visualMap={[]}
              />
            </Panel>
          </Col>
        </Row>
      </Grid>
    );
  }
}

DeviceQualityView.propTypes = propTypes;


const mapStateToProps = (state, props) => ({
  id: props.params.id,
});

export default connect(
  mapStateToProps,
  { pushState: routerActions.push },
)(injectIntl(DeviceQualityView));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/QualityView/coms/DeviceQualityView/index.jsx